import { FC } from "react";
import { TypedModalProps } from "./types";
import { Modal } from "./modal";

const ERROR_TITLE = "Oh oh...c'è stato un errore!";

export const ErrorModal: FC<TypedModalProps> = (props) => {
  const { title, ...rest } = props;
  return <Modal {...rest} type="error" title={title ?? ERROR_TITLE} />;
};
